import { cnpj } from 'cpf-cnpj-validator';

class CNPJValidatorAdapter {
  isValid (cnpjNumber) {
    return cnpj.isValid(cnpjNumber);
  }
}

export default CNPJValidatorAdapter;
